import { FunctionComponent } from 'react';
import styles from './ActivityLog.module.scss';

import Header from '../../components/Header';
import { useApiClientWrapper, useMarketplace } from 'hooks';
import ActivityLogTable from './ActivityLogTable';

interface ActivityLogProps {
    description?: string;
}

export const ActivityLog: FunctionComponent<ActivityLogProps> = props => {
    const apiClientWrapper = useApiClientWrapper();
    const marketplace = useMarketplace();

    const url = `/appointments_detail_export_data?marketplace_id=${apiClientWrapper.marketplaceId}`;

    const exportFile = {
        name: `Appointments Detail ${marketplace.basics.businessName}.csv`,
        url: url,
        apiClientWrapper: apiClientWrapper
    };

    const calendar = {
        optionSelected: 'Today'
    };

    return (
        <div className={styles.container}>
            <div>
                <span className={styles.description}> {props.description} </span>
            </div>
            <div>
                <Header
                    period={null}
                    onChangePeriod={() => {
                        undefined;
                    }}
                    exportFile={exportFile}
                    calendar={calendar}
                />
            </div>
            <div className={styles.tableContainer}>
                <ActivityLogTable />
            </div>
        </div>
    );
};

export default ActivityLog;
